module.exports = __webpack_public_path__ + "img/marquee.491eab48.png";